import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
  },
  {
    path: '/welcome',
    name: 'welcome',
    component: () => import('../views/Welcome.vue')
  },
  {
    path: '/dogs/dog_form',
    name: 'dogForm',
    component: () => import('../components/dogs/DogForm.vue')
  },
  {
    path: '/prices/list',
    name: 'get_pricelist',
    component: () => import('../components/pricing/GetPriceList.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router